var angular = require('angular');

var moment = require('js/lib/moment');

calendar.$inject = ['$timeout', '$document', 'modal'];

function calendar($timeout, $document, modal) {

  var unwatch;

  return {
    template: require('html/templates/openCalendar'),
    restrict: 'E',
    replace: true,
    scope: {
      date: '='
    },

    link: function(scope, element, attrs) {
      scope.today = moment().format('YYYY-MM-DD');
      scope.date = scope.date || scope.today;
      scope.dateString = scope.date;

      scope.openCalendar = function() {
        modal.open({
          scope: scope,
          klass: 'calendar-modal',
          body: require('html/templates/calendar')
        });

        $timeout(closeOnClickSelected, 0, false);
      };

      var closeOnClickSelected = function() {
        var selected = $document[0].querySelector('.pickadate-active');
        angular.element(selected).on('click', closeCalendar);
      };

      var closeCalendar = function() {
        scope._modal && scope._modal.close();
      };

      unwatch && unwatch();
      unwatch = scope.$watch('dateString', function(newDate, oldDate) {
        closeCalendar();
        if (newDate && newDate !== oldDate) {
          scope.date = newDate;
        }
      });

    }
  };
}

module.exports = calendar;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/directives/calendar.js
 ** module id = 137
 ** module chunks = 1
 **/